import { useThemeParams } from './useThemeParams'

export function useHandleWebHomeToRedirect() {
  const { data: schoolParams } = useThemeParams()
  const isActiveHomepage = schoolParams?.school?.publishedHomepage
  return isActiveHomepage ? '/p/home' : '/users/sign_in'
}
